module.exports = __webpack_public_path__ + "aa7615f9444592d294caabf8191aef27.docx";